import { Component,  OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HeaderCheckboxComponent } from '../core/grid/header-checkbox/header-checkbox.component';
import { GridRefreshComponent } from '../core/grid/grid-refresh/grid-refresh.component';
import { RowCheckboxComponent } from '../core/grid/row-checkbox/row-checkbox.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomTooltipComponent } from '../core/custom-tooltip/custom-tooltip.component';
import { GriddataService } from '../services/griddata.service';
import { ExcelService } from '../services/excel.service';
import * as mm from 'moment-timezone';
import { forkJoin, startWith, Subscription } from 'rxjs';
import { LookupService } from '../services/lookup/lookup.service';
import {  dateFilterComparator, getTimezone, resetSortingAndFilters, validateVanningDates } from '../constants';
import { OSPStateService } from '../services/osp-state.service';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig,
} from '@angular/material/legacy-dialog';
import { ConfirmCancelDailogComponent } from '../core/confirm-cancel-dailog/confirm-cancel-dailog.component';
import { warningMessage} from '../constants';
import {  logErrors } from '../shared/logger';
import { AgGridAngular } from 'ag-grid-angular';
import { RowCheckboxTapComponent } from './row-checkbox-tap';
import { ContainerTapService } from '../services/container-tap/container-tap.service';
import { DataServiceService } from '../services/air-freight-validation/data-service.service';
import { AllTappedQtyCellRendererComponent } from './all-tapped-qty-cell-renderer';
import { DefaultService } from '../services/default.service';
import { KanbanHistoryDialogComponent } from './kanbanHistory-dialog/kanpan-dialog.component';

@Component({
  selector: 'app-container-tap',
  templateUrl: './container-tap.component.html',
  styleUrls: ['./container-tap.component.scss'],
})
export class ContainerTapComponent implements OnInit, OnDestroy {
  showDownloadUploadButtons: boolean = true;
  // Arrays to track the quantities, dates, and times for each selected Kanban
  kanbanQtyList: string[] = ['1', '1', '1', '1', '1']; // For Quantity input
  namcValue = '';
  user = '';
  userRole = '';
  rowGroupingDisplayType = 'custom';
  groupDefaultExpanded = 10;
  rowData: any = [];
  @ViewChild('tapMainGrid') tapMainGrid: AgGridAngular;
  columnDefs;

  public defaultColDef;
  rowSelection;

  groupDisplayType = 'groupRows';
  autoGroupColumnDef;
  getDataPath;

  msgNoContent = 'No Content';
  gridOptions;
  paginationPageSize;
  paginationNumberFormatter;
  pagination = 'true';
  context: any;
  editType;
  suppressClickEdit = true;
  tooltipShowDelay = 0;
  frameworkComponents = { customTooltip: CustomTooltipComponent };
  editEnabled: boolean = false;
  freezeStatus: boolean = false;
  showToggleAll: boolean = false;
  showClear: boolean = true;
  validationMessage = '';
  originalKanbanList: any[] = [];
  disableDropdown: boolean = true;
  // variables used for navigation from procurement
  orderDetailsForEdit: any = null;
  for_edit = false;
  for_add_part = false;
  partdata = null;
  timeZone;

  // Sample static column definitions
  staticColumnDefs = [
    {
      headerName: '',
      field: 'rowCheckBox',
      width: 40,
      // headerComponentParams: {
      //   headerChecked: this.headerCheckboxChecked,
      // },
      headerComponentFramework: HeaderCheckboxComponent,
      floatingFilterComponentFramework: GridRefreshComponent,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellRendererFramework: RowCheckboxComponent,
      floatingFilter: false,
      pinned: 'left',
    },
  ];
  staticColumnDefs1 = [
    {
      headerName: ' Total KB Count',
      field: 'tot_kb_count',
      headerTooltip: 'Total KB Count',
      floatingFilter: true,
      valueGetter: (params) => {
        const containers = params.node.data.containers;
        const moduleNumber = params.node.data.module_number;
        // If container is an empty string or module number is "ALL", return container_renban
        if (moduleNumber === 'ALL') {
          return '';
        }
        // If containers is "expand", return module_number
        if (moduleNumber !== 'ALL') {
          return params.node.data.tot_kb_count;
        }
        // Default behavior: return container_renban or module_number (whichever is available)
        // return params.node.data.container_renban || moduleNumber;
      },
      width: 110,
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: ' Available KB Count',
      field: 'can_tap_kb_count',
      headerTooltip: 'Available KB Count',
      floatingFilter: true,
      cellRendererFramework: AllTappedQtyCellRendererComponent,  // Only first 5 columns get checkbox
      valueGetter: (params) => {
        const containers = params.node.data.containers;
        const moduleNumber = params.node.data.module_number;

        // If container is an empty string or module number is "ALL", return container_renban
        if (moduleNumber === 'ALL') {
          return '';
        }

        // If containers is "expand", return module_number
        if (moduleNumber !== 'ALL') {
          return params.node.data.can_tap_kb_count;
        }

        // Default behavior: return container_renban or module_number (whichever is available)
        // return params.node.data.container_renban || moduleNumber;
      },
      comparator: (valueA, valueB) => {
        const numA = parseFloat(valueA) || 0;
        const numB = parseFloat(valueB) || 0;
        return numA - numB;
      },
      width: 110,
      cellStyle: { textAlign: 'center' },
      sortable: true,
    },

    {
      headerName: 'Container Status',
      field: 'cnt_status',
      headerTooltip: 'Container Status',
      width: 150,
      sortable: true,
      floatingFilter: true,
    },
    {
      headerName: 'Estimated Arrival',
      sortable: true,
      resizable: true,
      width: 140,
      field: 'cnt_est_arr_dt',
      floatingFilter: true,
      headerTooltip: 'Estimated Arrival(mm/dd/yyyy)',
      valueGetter: (params) => {
        return params.node.data.cnt_est_arr_dt; // <--- what to show in the group column
      },
      cellRendererParams: {
        suppressCount: true,
      },
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },

      comparator: this.dateComparator,
    },
    {
      headerName: 'User Entry',
      field: 'user_entry',
      headerTooltip: 'User Entry',
      // tooltipValueGetter: (params) => {
      //   // Only show the tooltip if part_status is 'FULLY TAPPED', otherwise return null
      //   return params.data.part_status === 'FULLY TAPPED' ? params.data.user_entry : null;
      // },
      sortable: true,
      width: 270,
      floatingFilter: true,
      // valueGetter: (params) => {
      //   return params.data.part_status === 'FULLY TAPPED' ? params.data.user_entry : '';
      // },

      // tooltipField: 'user_entry',
    },
    {
      headerName: 'Planned Stock Date',
      sortable: true,
      resizable: true,
      width: 170,
      floatingFilter: true,
      field: 'planned_stocking_datetime',
      headerTooltip: 'Planned Stock Date(mm/dd/yyyy)',
      valueGetter: (params) => {
        return params.node.data.planned_stocking_datetime; // <--- what to show in the group column
      },
      cellRendererParams: {
        suppressCount: true,
      },
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },

      comparator: this.dateComparator,
    },
    {
      headerName: 'Updated DT',
      headerTooltip: 'Updated Date(mm/dd/yyyy hh:mm:ss (Eastern))',
      field: 'updated_date_time',
      width: 140,
      floatingFilter: true,
      tooltipField: 'updated_date_time',
    },
    {
      headerName: 'User',
      field: 'updated_userid',
      width: 150,
      floatingFilter: true,
      resizable: true,
      tooltipField: 'updated_userid',
      valueGetter: function (params) {
        // console.log('params', params);
        if (params.data) {
          if (params.data?.updated_userid?.startsWith('T_')) {
            return params.data.updated_userid.slice(2);
          } else {
            return params.data.updated_userid;
          }
        }
      },
    },
  ];

  // Dropdowns
  // selectedKanban: any = [];
  selectedKanban: any = ['', '', '', '', ''];
  // selectedDock: any ;
  selectedDestCode: any = [];
  selectedContainer: any = [];
  selectedSupplier: any = [];
  selectedDock: any = [];
  selectedSpecialist: any = [];
  selectedLifecycle: any = [];
  successMessage = '';
  warningMessage = '';
  vanningFrom: any;
  vanningTo: any;
  selectedContainerFrom: any;
  selectedModule: any;
  selectedContainerTo: any;
  kanbanListSelected = [];
  // Dropdown Options
  kanbanList: any = [];
  kanbanListCopy: any = [];
  ccListCopy: any = [];

  dockList: any = [];
  dockListCopy: any = [];

  destCodeList: any = [];
  containerList: any = [];
  containerFromToList: any = [];
  containerFromToListCopy: any = [];
  containerFromToListCopy2: any = [];


  supplierList: any = [];
  // dockList: any = [];
  specialistList: any = [];
  lifecycleList: any = [];
  adjCodeList: any = [];
  rowCount: number = 0;
  isEditMode: boolean = false;
  dataCount: number = 0;
  offset: number = 0;
  statusList: any = [];
  selectedStatus: any = [];

  orig_min_qty = 'FA Min Original';
  orig_max_qty = 'FA Max Original';
  rev_min_qty = 'FA Min Final';
  rev_max_qty = 'FA Max Final';

  showHideList: any = [
    // { value: 'container_renban', label: 'Container' },
    { value: 'tot_kb_count', label: 'Total KB Count' },
    { value: 'can_tap_kb_count', label: 'Available KB Count' },

    // { value: '`Kanban ${kanban}`', label: '`kanban_${kanban}`' },
    { value: 'cnt_status', label: 'Container Status' },
    { value: 'cnt_est_arr_dt', label: 'Estimated Arrival' },

    { value: 'user_entry', label: 'User Entry' },
    { value: 'planned_stocking_datetime', label: 'Planned Stock Date' },
    { value: 'updated_date_time', label: 'Updated DT' },
    { value: 'updated_userid', label: 'User' },
  ];

  selectedShowHideList: any = [...this.showHideList];

  kanbanSelected = 1;
  disablePartNumber: boolean;
  disableKanban: boolean;
  // Dropdowns

  selectedLinePath: any = [];

  // Dropdown Options
  linePathList: any = [];

  page = 0;
  apiDefaultLimit = 5000;
  icons: { groupExpanded: string; groupContracted: string };
  commentsList: any = [];

  uploadError: boolean;
  uploadEnabled: boolean;
  namcName: string;
  files: any[];
  fileBuffer: any;

  exportData: any;

  minVanDate: any;
  maxVanDate: any;

  uploading: boolean = false;

  displayNames = {
    vanning_date: 'Van DT',
    item_id: 'Part No',
    kanban: 'Kanban',
    order_lot: 'QPC',
    cont_code: 'CC',
    orig_min_qty: this.orig_min_qty,
    orig_max_qty: this.orig_max_qty,
    rev_min_qty: this.rev_min_qty,
    rev_max_qty: this.rev_max_qty,
  };

  editApiDefaultLimit = 200;
  timesEditApiCalled: number = 0;
  editApiStartPosition: number = 0;
  editApiEndPosition: number = this.editApiDefaultLimit;
  batchRunLogID: any;
  headerHeight: number;
  loading: any;

  containerTapSubscription$: Subscription;
  headerCheckboxChecked: boolean = false;
  allowedFilesize: number;
  onInitVanningFrom: any;
  onInitVanningTo: any;
  justFileName: any;
  validating: boolean;
  itContact: string;
  easternDate: any;
  defaultPageSize: any = 100000;
  kanbanSearchValue: any;
  flalLicenseKeySubscription$: Subscription;
  showDropdown: boolean = true; // Controls if the dropdown is visible or not
  containerFromList: any[];
  containerToList: any[];
  filteredData$: Subscription;
  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly excelService: ExcelService,
    private readonly gridDataService: GriddataService,
    private readonly lookupService: LookupService,
    private readonly containerTapService: ContainerTapService,
    private readonly stateService: OSPStateService,
    private dataService: DataServiceService,
    public dialog: MatDialog,
    private readonly defaultService: DefaultService
  ) {
    this.context = {
      componentParent: this,
    };
  }

  headers = [
    'Container',
    // '`kanban_${kanban}`',
    'KB Count',
    'Container Status',
    'Estimated Arrival',
    'User Entry',
    'Planned Stock Date',
    'Updated DT',
    'User',
  ];

  headersSameAsUI = [
    'Container',
    // '`kanban_${kanban}`',
    'KB Count',
    'Container Status',
    'Estimated Arrival',
    'User Entry',
    'Planned Stock Date',
    'Updated DT',
    'User',
  ];

  fileName: string = '';
  access1;

  // DATE COMPARATOR FOR SORTING
  dateComparator(date1, date2) {
    function monthToNum(date) {
      if (date === undefined || date === null) {
        return null;
      }

      const newDate: Date = new Date(date);

      const yearNumber = newDate.getFullYear();
      const monthNumber = newDate.getMonth();
      const dayNumber = newDate.getDate();
      const hoursNumber = newDate.getHours();
      const minutesNumber = newDate.getMinutes();

      const result = yearNumber * 10000 + monthNumber * 100 + dayNumber + hoursNumber * 60 + minutesNumber * 10;
      // 29/08/2004 => 20040829
      return result;
    }

    const date1Number = monthToNum(date1);
    const date2Number = monthToNum(date2);

    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }

    return date1Number - date2Number;
  }

  ngOnDestroy(): void {
    this.containerTapSubscription$.unsubscribe();
    if (this.filteredData$) {
      this.filteredData$.unsubscribe();
      this.orderDetailsForEdit = [];
    }
  }

  ngOnInit(): void {
    let showData = localStorage.getItem('FromDevan');
          setTimeout(() => {
        this.attachHeaderClickEvents();
      });

    if (showData === 'true') {
      this.filteredData$ = this.dataService.filteredData$.subscribe((data: any) => {
        if (data) {
          // console.log(data, 'data..........');
          this.orderDetailsForEdit = data;
        }
      });
    } else {
      this.orderDetailsForEdit = [];
    }
    localStorage.setItem('FromDevan', 'false');

    this.gridOptions = this.gridDataService.getGridOptions();
    this.gridOptions.onGridReady = function (params) {
      params.api.hideOverlay();
      this.gridApi = params.api;
    };

    this.icons = {
      groupExpanded:
        '<img src="/assets/images/cellgrid_minus.png" style="height: 18px; width: 18px;padding-right: 2px"/>',
      groupContracted:
        '<img src="/assets/images/cellgrid_plus.png" style="height: 14px; width: 14px;padding-right: 2px"/>',
    };

    this.getDataPath = function (data) {
      return data.group;
    };

    this.autoGroupColumnDef = {
      headerName: 'Container',
      sortable: true,
      resizable: true,
      headerTooltip: 'Container',
      width: 130,
      floatingFilter: true,
      // headerTooltip: 'Vanning Date(mm/dd/yyyy)',
      valueGetter: (params) => {
        const containers = params.node.data.containers;
        const moduleNumber = params.node.data.module_number;

        // If container is an empty string or module number is "ALL", return container_renban
        if (moduleNumber === 'ALL') {
          return params.node.data.container_renban;
        }
        if (moduleNumber === 'ALL') {
          return (params.node.data.can_tap_kb_count = '');
        }

        // If containers is "expand", return module_number
        if (moduleNumber !== 'ALL') {
          return moduleNumber;
        }

        // Default behavior: return container_renban or module_number (whichever is available)
        // return params.node.data.container_renban || moduleNumber;
      },
      cellRendererParams: {
        suppressCount: true,
      },
      // filter: 'agDateColumnFilter',
      // filterParams: {
      //   comparator: dateFilterComparator,
      // },

      // comparator: this.dateComparator,
    };
    this.gridOptions.defaultColDef.floatingFilter = true;
    // Initialize the grid with static columns
    this.columnDefs = [...this.staticColumnDefs, ...this.staticColumnDefs1];
    this.headerHeight = 45;

    this.rowSelection = 'multiple';
    this.editType = 'fullRow';
    this.setPageSizeToAll(this.defaultPageSize);
    this.containerTapSubscription$ = this.stateService.getNamc().subscribe((observable) => {
      this.initializeData();
    });
  }

  updateGridColumns(): void {

    const selectedColumns = this.selectedKanban.map((kanban, index) => ({
      headerName: `Kanban ${kanban}`,
      field: `kanban_${kanban}`,
      width: 120,
      floatingFilter: true,
      sortable: true,
      filter: true,

      cellRendererFramework: index < 5 ? RowCheckboxTapComponent : null,
      headerTooltip: `Click here to view the history of ${kanban}`,

      headerComponent: 'agColumnHeader',

      headerComponentParams: {
      template: `
        <div class="ag-cell-label-container" role="presentation">

          <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>

          <div ref="eLabel" class="ag-header-cell-label" role="presentation"
              style="display:flex; align-items:center; gap:8px; color:#000; opacity:1;">

            <!-- CLICKABLE TEXT -->
            <span class="custom-header-link"
                  data-field="kanban_${kanban}"
                  style="color:#1976d2; cursor:pointer; font-weight:500;">

              Kanban ${kanban}

            </span>

            <!--  SORT ICONS -->
            <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
            <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>
            <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>
            <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>

          </div>
        </div>
  `
      }
      }));

    // Update columnDefs by merging static and dynamic columns
    this.columnDefs = [
      ...this.staticColumnDefs, // Static columns
      ...selectedColumns,       // Dynamically generated Kanban columns
      ...this.staticColumnDefs1 // Static columns1
    ];

    // After updating the columnDefs, update grid data
    this.updateGridData();
  }
  onKanbanCheckboxChange(event: Event, kanbanToRemove: string): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (!isChecked) {
      // Remove from selectedKanban
      this.selectedKanban = this.selectedKanban.filter(k => k !== kanbanToRemove);

      // Update quantities accordingly
      this.kanbanQtyList = this.selectedKanban.map(() => '1');

      // Enable dropdown if less than 5 Kanbans selected
      this.disableDropdown = this.selectedKanban.length >= 5;

      // Update kanbanList disabled state to reflect new selection
      const isFiveSelected = this.selectedKanban.length === 5;
      this.kanbanList = this.kanbanList.map(kanban => ({
        ...kanban,
        disabled: isFiveSelected && !this.selectedKanban.includes(kanban.kanban),
      }));

      // Update the grid columns
      this.updateGridColumns();
      this.updateGridData();

      setTimeout(() => {
        this.attachHeaderClickEvents();
      });
    }
  }
  getKanbanFieldValue(kanban: string): string {
    // console.log('Searching for Kanban:', kanban);
    // console.log('Row Data:', this.rowData);
    // Create the dynamic field name like 'kanban_0001' based on the selected kanban value
    const field = `kanban_${kanban}`; // Construct field name like 'kanban_0001'
    // Find the item in rowData where the kanban key matches
    const dataItem = this.rowData.find((item) => item && item.kanban === kanban);
    // console.log('Found Data Item:', dataItem);
    if (dataItem) {
      // Access the dynamically created field name from dataItem
      const value = dataItem[field];
      console.log(`Found value for ${field}:`, value);
      return value || 'No value'; // Return 'No value' if the value is undefined
    }
    console.log('No matching Kanban found');
    return 'No value'; // Return 'No value' if no item is found
  }

  onKanbanChange() {
    this.removeMessage();
    // Ensure the number of selected Kanban values does not exceed 5
    if (this.selectedKanban.length > 5) {
      this.selectedKanban = this.selectedKanban.slice(0, 5); // Limit to the first 5 selected Kanban
    }

    // Check if 5 Kanban values are selected
    const isFiveSelected = this.selectedKanban.length === 5;

    // Update the Kanban list (disable only the unselected options)
    this.kanbanList = this.kanbanList.map((kanban) => {
      return {
        ...kanban,
        disabled: isFiveSelected && !this.selectedKanban.includes(kanban.kanban),
        // disabled: !isFiveSelected && this.selectedKanban.some((selected) => selected.kanban === kanban.kanban),
      };
    });
    // this.kanbanQtyList = this.selectedKanban.map(() => ( '1' )); // Qty required
    // Dynamically update grid data based on selected Kanban values
    // Preserve existing quantities for selected Kanban options
    const existingQuantities = this.kanbanQtyList.slice(); // Copy existing quantities

    // Update the kanbanQtyList based on selected Kanban options
    this.kanbanQtyList = this.selectedKanban.map((kanban, index) => {
      // If there's an existing quantity for this Kanban, keep it; otherwise, set it to an empty string
      return existingQuantities[index] !== undefined ? existingQuantities[index] : '1';
    });
    // Close the dropdown if 5 Kanban values are selected
    if (isFiveSelected) {
      this.showDropdown = false;
    }
    this.updateGridColumns();
    this.updateGridData();

    setTimeout(() => {
      this.attachHeaderClickEvents();
    });
  }
  onDropdownShow() {
    if (this.selectedKanban.length === 5) {
      this.showDropdown = false; // Close the dropdown if 5 Kanban values are selected
    }
  }
  updateGridData() {
    this.gridOptions.api.setFilterModel({ kanban: this.selectedKanban });
    // console.log('Selected Kanban:', this.selectedKanban);
  }

  initializeData() {
    // this.onResetDropDown();
    this.itContact = localStorage.getItem('itContact');

    // this.resetVariablesState();
    this.spinner.show();
    this.rowData = [];
    this.selectedModule = '';
    this.namcValue = localStorage.getItem('namcvalue');
    this.namcName = localStorage.getItem('namcName');
    this.user = localStorage.getItem('workdayId');
    this.userRole = localStorage.getItem('UserRoles');
    this.timeZone = getTimezone(this.namcValue);
    localStorage.setItem('timezone', this.timeZone)



    this.loadDrop();
    this.onResetDropDown();
  }

  //freezing logic
  batchCheck = true;
  freezingMesssage = '';

  loadDrop() {
    this.spinner.show();
    // this.onResetDropDown();
    this.timeZone = getTimezone(this.namcValue);
    localStorage.setItem('timezone', this.timeZone)


    const data = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
    };

    const lookupSubscriptions = [
      this.containerTapService.getKanban(data),
      this.containerTapService.getDock(data),
      this.containerTapService.getContainerCode(data),
      this.lookupService.getUserShowHideColumns(),
      // this.service.getLifeCycle(this.namcValue, this.userRole, this.user),
      this.containerTapService.getStatus(data),
    ];

    forkJoin(lookupSubscriptions).subscribe({
      next: (res) => {
        //if kanbanList, add ALL option
        this.kanbanList = [];
        this.kanbanListCopy = [];
        this.ccListCopy = [];
        this.dockList = [];
        this.dockListCopy = [];
        this.containerList = [];
        this.lifecycleList = [];
        this.statusList = [];
        this.containerFromToList = [];
        this.containerFromToListCopy = [];
        this.containerFromToListCopy2 = [];

        this.containerFromList = [];
        this.containerToList = [];

        if (res[0].body) {
          // this.kanbanList.push(...res[0].body);
          // this.kanbanListCopy = this.kanbanList
          if (res[0]?.body && Array.isArray(res[0].body)) {
            this.kanbanList.push(...res[0].body);
            this.kanbanListCopy = this.kanbanList;
            this.kanbanList = this.kanbanList.filter(
              (value, index, self) => index === self.findIndex((t) => t.kanban === value.kanban)
            );
          }
        }
        // this.kanbanList.push(res[0].body.data);

        //if item id list, add ALL option
        if (res[1].body) {
          // this.dockList.push(...res[1].body);
          if (res[1]?.body && Array.isArray(res[1].body)) {
            this.dockList.push(...res[1].body);
            this.dockListCopy = this.dockList;
            this.dockList = this.dockList.filter(
              (value, index, self) => index === self.findIndex((t) => t.dock === value.dock)
            );
          }
        }

        // this.dockList.push(...res[1].body.data);

        if (res[1].body) {
          this.containerList.push({ cc: 'ALL' });
        }
        this.containerList.push(...res[1].body);
        this.ccListCopy = this.containerList;
        this.containerList = this.containerList.filter(
          (value, index, self) => index === self.findIndex((t) => t.cc === value.cc)
        );
        this.containerFromToList.push(...res[2].body);
        this.containerFromToList = Array.from(
          new Set(this.containerFromToList.map((item) => item.container_renban))
        ).map((uniqueRenban) => this.containerFromToList.find((item) => item.container_renban === uniqueRenban));

        // Sort properly (handles numbers and letters)
        this.containerFromToList.sort((a, b) =>
          a.container_renban.localeCompare(b.container_renban, undefined, { numeric: true, sensitivity: 'base' })
        );
        this.containerFromToListCopy2 = this.containerFromToList;
        this.containerFromToListCopy = this.containerFromToList;
        this.containerFromList = [...this.containerFromToList];
        this.containerToList = [...this.containerFromToList];

        if (res[4]?.body && Array.isArray(res[4].body)) {
          this.selectedStatus = res[4].body.filter(
            (order) => order.container_status === 'NAMC ARRIVED' || order.container_status === 'IN-TRANSIT'
          );
          this.statusList.push(...res[4].body);
        } else {
          this.selectedStatus = [];
        }
        const { fa_columns } = res[3].body.showHideColumnsResponse;

        try {
          const hideItems = JSON.parse(fa_columns);

          if (typeof hideItems === 'object' && hideItems.length > 0) {
            this.selectedShowHideList = this.showHideList.filter(
              (sItem) => !hideItems.map((item) => item.value).includes(sItem.value)
            );

            this.onShowHideChange({
              value: this.selectedShowHideList,
              onInit: true,
            });
          }
        } catch (error) { }
        if (this.assignDefaultDock()) {
          this.onDockChange();
        }
        this.spinner.hide();
      },
      complete: () => {
        if (this.orderDetailsForEdit.length != 0) {
          this.appendprocurementDetails();
        }
      },

      error: (error) => this.errorCallback(error),
    });
  }

  errorCallback = (error, apiName = '') => {
    logErrors(error);
    this.spinner.hide();
    this.uploading = false;
    this.validating = false;

    let detailedMessage = '';
    const backendMessage = error?.error?.message;

    if (backendMessage?.required_fields) {
      detailedMessage = `${warningMessage.requiredFieldsMissing} ${this.itContact}.`;
    } else if (backendMessage) {
      detailedMessage = `${warningMessage.apiLogicFail} ${this.itContact}. | ${backendMessage}`;
    } else if (error?.message) {
      detailedMessage = `${warningMessage.apiLogicFail} ${this.itContact}. | ${error.message}`;
    } else if (apiName) {
      detailedMessage = `${warningMessage.apiLogicFail} ${this.itContact}. | Error in ${apiName}`;
    } else {
      detailedMessage = `${warningMessage.apiLogicFail} ${this.itContact}.`;
    }

    this.warningMessage = detailedMessage;
    this.rowData = [];
    this.tapMainGrid.gridOptions.api.setRowData(this.rowData);
  };

  checkIfAnySelected() {
    this.validationMessage = '';
    const msgPrefix = 'Please ';
    let msgArr = [];

    // Check if 'selectedDock' is empty
    if (Object.keys(this.selectedDock).length === 0) {
      msgArr.push('Dock');
    }

    // Check if 'selectedKanban' is empty
    if (this.selectedKanban.length === 0) {
      msgArr.push('Kanban');
    }

    // Check if 'kanbanQtyList' contains empty 'qty' values
    const anyEmptyQty = this.kanbanQtyList.some((kanbanQty) => !kanbanQty || kanbanQty.trim() === '');
    // console.log(anyEmptyQty, 'anyEmptyQty');
    // console.log(this.kanbanQtyList, 'kanbanQtyList');

    if (anyEmptyQty) {
      msgArr.push('enter the Qty required');
    }

    // If both Dock and Kanban are missing, show the combined message
    if (msgArr.includes('Dock') && msgArr.includes('Kanban')) {
      msgArr = ['select Dock and Kanban'];
    } else {
      // Otherwise, apply the "select" prefix as needed
      msgArr = msgArr.map((item) => (item === 'Dock' || item === 'Kanban' ? `select ${item}` : item));
    }

    // If there are validation messages, concatenate them with "and"
    if (msgArr.length > 0) {
      this.validationMessage = `${msgPrefix}${msgArr.join(' and ')}.`;
      return false;
    }

    return true;
  }

  clearKanbanValue() {
    this.kanbanSearchValue = null;
  }

  // Function to separate dynamic kanban values
  separateKanbanValue(key: string, kanbanValue: string): any | null {
    const regex = /(\d+)\((\d+)\)/;
    const matches = kanbanValue.match(regex);

    if (matches) {
      const part1 = matches[1]; // The value before the parentheses (e.g., "12")
      const part2 = matches[0]; // The full value including parentheses (e.g., "12(144)")

      return {
        key, // The dynamic key (e.g., 'kanban_4625')
        part1, // "12"
        part2, // "12(144)"
      };
    } else {
      return null; // If no match, return null
    }
  }

  // Function to process kanban values from the response data
  processKanbanValues(response: any): any[] {
    const result: any[] = [];

    for (const key in response) {
      if (key.startsWith('kanban_')) {
        const kanbanValue = response[key];
        const separatedValue = this.separateKanbanValue(key, kanbanValue);

        if (separatedValue) {
          result.push(separatedValue);
        }
      }
    }
    return result;
  }

  onSearch(offset) {
    // console.log(this.selectedDock);
    // console.log(this.selectedKanban);
    // if (removeMessage) {
    this.removeMessage();
    // }
              setTimeout(() => {
        this.attachHeaderClickEvents();
      });


    if (offset === 0) {
      this.setPageSizeToAll(this.defaultPageSize);
      this.resetVariablesState();
      this.rowData = [];
      this.tapMainGrid.gridOptions.api.setRowData(this.rowData);

      this.offset = 0;
      this.spinner.show();
    }

    if (!this.checkIfAnySelected()) {
      this.rowData = [];
      this.warningMessage = this.validationMessage;

      window.scroll(0, 0);

      this.spinner.hide();

      return false;
    }

    this.tapMainGrid.gridOptions.api.showLoadingOverlay();

    this.loading = true;
    localStorage.setItem('dock', this.selectedDock.dock);
    const data = {
      offset: offset,
      limit: this.apiDefaultLimit,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      userid: localStorage.getItem('UserName'),
      //  kanban: this.selectedKanban.map((e) => e),
      dock: this.selectedDock.dock,

      kanban: this.selectedKanban,
      qty: this.kanbanQtyList,
      cc: this.selectedContainer.map((e) => e.cc),
      containerTo: this.selectedContainerTo?.container_renban,
      containerFrom: this.selectedContainerFrom?.container_renban,
      module_number: this.selectedModule,
      container_status: this.selectedStatus.map((e) => e.container_status),
      currenteasternDate: this.easternDate,
    };

    //if all selected
    if (data.kanban.includes('ALL')) {
      data.kanban = [];
    }

    if (data.dock.includes('ALL')) {
      data.dock = [];
    }

    if (data.cc.includes('ALL')) {
      data.cc = [];
    }

    this.containerTapService.getContainerTap(data)?.subscribe({
      error: (error) => this.errorCallback(error, 'getContainerTap'),
      next: (res) => {
        if (res.body && res.body.data) {
          // 1. Fields to clean
          const kanbanFields = this.selectedKanban.map(k => `kanban_${k}`);

          // 2. Transform all kanban fields in each row
          const cleanedData = res.body.data.map(item => {
            const cleanedItem = { ...item };
            kanbanFields.forEach(field => {
              const val = cleanedItem[field];
              if (val === '0(0)' || val === '0' || val === 0 || val === "NaN" || val === startWith('Nan')) {
                cleanedItem[field] = null; // replace with empty string
              }
            });
            return cleanedItem;
          });

          // 3. Sort by can_tap_kb_count descending
          const sortedData = cleanedData.sort((a, b) => {
            const countA = Number(a.can_tap_kb_count) || 0;
            const countB = Number(b.can_tap_kb_count) || 0;
            return countB - countA;
          });

          // 4. Push and bind
          this.rowData.push(...sortedData);
          this.tapMainGrid.gridOptions.api.setRowData(this.rowData);

          this.dataCount = parseInt(res.body.data.rowCount);
          const records = this.dataCount - (this.offset + 1) * 8000;

          if (records >= 1) {
            this.offset++;
            this.onSearch(this.offset * 8000);
          } else {
            this.spinner.hide();
          }
        } else {
          this.rowData = [];
          this.spinner.hide();
        }

        this.setPageSizeToAll();
      }
    });
  }

  onPageSizeChanged() {
    if (this.gridOptions?.api) {
      this.gridOptions.api.paginationSetPageSize(Number(this.paginationPageSize));
    }
  }

  setPageSizeToAll(pageSize?) {
    this.paginationPageSize = this.rowData.length;

    if (pageSize) {
      this.paginationPageSize = 0;
      this.rowData.length = 0;
    }

    this.onPageSizeChanged();
  }

  canDeactivate() {
    return this.editEnabled;
  }

  getModifiedRowData(): any {
    const modifiedRowData = this.rowData.filter((row) => row.rowCheckBox && row.cont_code !== 'ALL');
    return modifiedRowData;
  }

  getSelectedRows(): any {
    const modifiedRowData = this.rowData.filter((row) => row.rowCheckBox);
    return modifiedRowData;
  }

  onResetDropDown() {
    this.removeMessage();
    this.selectedModule = '';
    this.disableDropdown = true;
    this.selectedKanban = [];
    this.kanbanList = [];
    this.kanbanList = this.kanbanListCopy;
    this.containerFromList = [];
    this.containerToList = [];
    this.containerFromToList = this.containerFromToListCopy2;
    this.containerToList = this.containerFromToListCopy;
    this.selectedDock = [];
    this.selectedDestCode = [];
    this.selectedContainer = [];
    this.selectedSupplier = [];
    this.selectedDock = [];
    this.selectedSpecialist = [];
    // this.selectedStatus = [];
    this.kanbanSearchValue = null;
    this.containerFromList = [...this.containerFromToList];
    this.containerToList = [...this.containerFromToList];

    this.vanningFrom = this.onInitVanningFrom;
    this.vanningTo = this.onInitVanningTo;
    this.selectedContainerFrom = [];
    this.selectedContainerTo = [];
    this.kanbanList = this.kanbanList.filter(
      (value, index, self) => index === self.findIndex((t) => t.kanban === value.kanban)
    );

    this.setPageSizeToAll(this.defaultPageSize);

    this.rowData = [];
    this.disableKanban = false;
    this.disablePartNumber = false;
    // Reset the kanbanQtyList to clear quantities
    this.kanbanQtyList = this.selectedKanban.map(() => ({ qty: '' })); // Reset quantities to empty strings
    if (this.tapMainGrid) {
      this.headerCheckboxChecked = false;
      this.tapMainGrid.gridOptions.api.refreshHeader();
      this.resetGrid();
                setTimeout(() => {
        this.attachHeaderClickEvents();
      });

    }
    // **Step 1: Clear only dynamically generated Kanban columns**
    const selectedColumns = this.selectedKanban.map((kanban, index) => ({
      headerName: `Kanban ${kanban}`, // Header with Kanban number
      field: `kanban_${kanban}`, // The dynamic field name based on kanban key
      width: 110, // Set width for each column
      floatingFilter: true, // Disable floating filters for these columns
      cellRendererFramework: index < 5 ? RowCheckboxTapComponent : null, // Only first 5 columns get checkbox
      headerTooltip: `Kanban ${kanban}`, // Add a tooltip to the header
      cellRendererParams: {
        fieldValue: this.getKanbanFieldValue(kanban), // Pass the actual field value to the checkbox component
        kanbanKey: kanban, // Provide the kanban key as context
        value: this.getKanbanFieldValue(kanban) !== 'No value', // Set checkbox value to true/false based on value
      },
    }));

    // Remove the dynamic columns from the column definitions
    const resetColumnDefs = [
      ...this.staticColumnDefs, // Static columns
      ...this.staticColumnDefs1, // Static columns1
    ];

    // **Step 2: Update columnDefs by merging static columns**
    this.columnDefs = resetColumnDefs;

    // **Step 3: Call updateGridColumns to refresh column definitions (if necessary)**
    if (this.tapMainGrid && this.tapMainGrid.gridOptions.api) {
      this.tapMainGrid.gridOptions.api.setColumnDefs(this.columnDefs); // Set updated column definitions
      this.tapMainGrid.gridOptions.api.sizeColumnsToFit(); // Optionally: Adjust column sizing
    }

    // **Step 4: Reset row data (if necessary)**
    if (this.tapMainGrid && this.tapMainGrid.gridOptions.api) {
      this.tapMainGrid.gridOptions.api.setRowData([]); // Clear existing rows
      this.tapMainGrid.gridOptions.api.refreshCells(); // Refresh grid cells
      this.tapMainGrid.gridOptions.api.refreshHeader(); 
      // Refresh the headers to reflect column changes
                setTimeout(() => {
        this.attachHeaderClickEvents();
      });

    }
    // Step 5: Trigger change detection for the dropdown reset (if needed)
    if (this.selectedKanban.length === 0) {
      // Reset dropdown value manually if required
      this.kanbanList?.forEach((kanban) => (kanban.disabled = false)); // Enable all options again if required
    }
  }

  resetGrid() {
    if (this.tapMainGrid) {
      resetSortingAndFilters(this.tapMainGrid);

      return;
    }
  }

  enableDisableRowNode(rowIndex, checked) {
    const rowNode = this.tapMainGrid.gridOptions.api.getDisplayedRowAtIndex(rowIndex);

    if (checked === true) {
      rowNode.setSelected(true);
      if (this.isEditMode) {
        rowNode.data.checkedEditMode = true;
      }
      rowNode.data.rowCheckBox = true;
    } else {
      rowNode.setSelected(false);
      rowNode.data.checkedEditMode = false;
      rowNode.data.rowCheckBox = false;
    }

    this.gridOptions.getRowStyle = function (params) {
      if (params.node.rowIndex === rowIndex) {
        const color = checked ? '#E4ECF0' : 'white';
        return { background: color };
      }
      return { background: 'white' };
    };

    rowNode.setData(rowNode.data);
  }

  userCheckChanged(checked, rowIndex) {
    if (
      this.warningMessage === 'Please select at least one row to edit.' ||
      this.warningMessage === 'No rows are selected.'
    ) {
      this.warningMessage = '';
    }
    this.spinner.show();

    const rowNode = this.tapMainGrid.gridOptions.api.getDisplayedRowAtIndex(rowIndex);

    // All leaf nodes (includes parent node)
    const leafNodesIndexes = rowNode.allLeafChildren.map((childNode) => childNode.rowIndex);

    // console.log(rowNode);
    // console.log(leafNodesIndexes);

    // Enable/Disable all leaf nodes
    for (let index = 0; index < leafNodesIndexes.length; index++) {
      const leafNodeIndex = leafNodesIndexes[index];
      this.enableDisableRowNode(leafNodeIndex, checked);
    }

    // If any child row is checked/unchecked
    const parentNode = rowNode.parent;
    if (parentNode.rowIndex) {
      // If child row is unchecked
      if (checked === false) {
        this.enableDisableRowNode(parentNode.rowIndex, checked);
      }

      // If child row is checked
      const childrenCount = parentNode.allChildrenCount; // Children count (excluding parent node)

      // All checked leaf nodes (includes parent)
      const checkedChildrenCount = parentNode.allLeafChildren.filter((childNode) => childNode.data.rowCheckBox).length;

      // console.log(
      //   childrenCount,
      //   checkedChildrenCount,
      //   childrenCount === checkedChildrenCount
      // );

      // Self explanatory
      if (childrenCount === checkedChildrenCount) {
        this.enableDisableRowNode(parentNode.rowIndex, checked);
      }
    }

    this.toggleHeaderCheckbox(checked);
    this.spinner.hide();
  }

  onHeaderCellClicked(params) {
    const target = params.event.target as HTMLElement;

    console.log('CLICK TARGET:', target); //  add this for debug

    if (target.classList.contains('custom-header-link')) {
      const field = target.getAttribute('data-field');
      console.log("open popup")
      // this.openKanbanPopup(field);

      //  stop sorting
      params.event.stopPropagation();
    }
  }

  headerCheckChanged(event) {
    if (
      this.warningMessage === 'Please select at least one row to edit.' ||
      this.warningMessage === 'No rows are selected.'
    ) {
      this.warningMessage = '';
    }
    const headerChecked = event.checked;

    this.headerCheckboxChecked = event.checked;

    const isEditable = this.isEditMode;

    this.tapMainGrid.gridOptions.api.forEachNode((rowNode) => {
      if (headerChecked) {
        rowNode.data.rowCheckBox = true;

        if (isEditable) {
          rowNode.data.checkedEditMode = true;
        }
      } else {
        rowNode.data.rowCheckBox = false;
        rowNode.data.checkedEditMode = false;
      }

      rowNode.setData(rowNode.data);
    });
  }

  toggleHeaderCheckbox(checked) {
    if (!checked) {
      this.headerCheckboxChecked = false;

      this.tapMainGrid.gridOptions.api.refreshHeader();
                setTimeout(() => {
        this.attachHeaderClickEvents();
      });


      return;
    }

    const rowCount = this.tapMainGrid.gridOptions.rowData.length;
    const selectedRowCount = this.tapMainGrid.gridOptions.rowData.filter((x) => x.rowCheckBox === true).length;

    if (rowCount === selectedRowCount) {
      this.headerCheckboxChecked = true;

      this.tapMainGrid.gridOptions.api.refreshHeader();
                setTimeout(() => {
        this.attachHeaderClickEvents();
      });

    }
  }

  async onDockChange() {
    this.disableDropdown = false;
    this.removeMessage();
    this.selectedKanban = [];
    this.selectedContainer = [];
    this.kanbanList = [];
    this.containerFromToListCopy = [];
    this.containerFromList = []
    this.containerFromToListCopy = this.containerFromToListCopy2
    this.kanbanList = this.kanbanListCopy; // Restore the original list for filtering
    this.containerList = this.dockListCopy;
    this.containerFromList = [];
    this.containerFromToList = []
    this.containerToList = []


    // Ensure selectedDock has a valid dock value
    if (this.selectedDock && this.selectedDock.dock) {
      // console.log('Selected Dock:', this.selectedDock.dock);

      // Filter the original kanban list based on the selected dock
      const filteredKanbanList = this.kanbanList.filter((item) => item.dock === this.selectedDock.dock);
      const filtercclist = this.containerList.filter((item) => item.dock === this.selectedDock.dock);
      this.containerList = filtercclist.filter(
        (value, index, self) => index === self.findIndex((t) => t.cc === value.cc)
      );
      // Get all valid cc codes from containerList
      this.containerFromToListCopy = this.containerFromToListCopy.filter(
        (item) =>
          this.containerList.some((ccItem) =>
            item.container_renban.startsWith(ccItem.cc)
          )
      );
      this.containerFromList = this.containerFromToListCopy
      this.containerToList = this.containerFromToListCopy
      this.containerFromToList = this.containerFromToListCopy


      if (filteredKanbanList.length > 0) {
        // Sort the filtered list by kanban in ascending order
        const sortedKanbanList = filteredKanbanList.sort((a, b) => a.kanban.localeCompare(b.kanban));
        this.kanbanList = sortedKanbanList; // Update kanbanList with sorted results
      } else {
        console.warn('No matches found for the selected dock.');
        this.kanbanList = []; // Clear the list if no matches are found
      }
    } else {
      console.error('Invalid dock selection. Please select a valid dock.');
      this.kanbanList = []; // Clear the list if no valid dock is selected
    }
    this.defaultService.setDockCode(JSON.stringify([{ dock: this.selectedDock.dock }]));
  }

  assignDefaultDock() {
    try {
      if (this.dockList?.length > 0) {
        const defaultdockArray: any[] = JSON.parse(this.defaultService.getCurrentDockCode());
        if (Array.isArray(defaultdockArray)) {
          const validDocks = new Set(defaultdockArray.map(item => item.dock));
          this.selectedDock = this.dockList.find(item => validDocks.has(item.dock));
          if (this.selectedDock) {
            return true;
          }
        }
      }
      return false;
    } catch (error) {
      console.log('Error in assigning default dock', error);
      return false;
    }
  }

  onContainerChange(): void {
    this.containerFromList = [];
    this.containerToList = [];


    this.containerFromList = this.containerFromToListCopy;
    this.containerToList = this.containerFromToListCopy;
    this.containerFromToList = this.containerFromToListCopy;

    if (this.selectedContainer.length >= 1) {
      if (this.selectedContainer[this.selectedContainer.length - 1].cc === 'ALL') {
        this.selectedContainer = [];
        this.selectedContainer.push(this.containerList[0]);
        // Show all containers in both lists if "ALL" is selected
        this.containerFromList = this.containerFromToListCopy;
        this.containerToList = this.containerFromToListCopy;
        this.containerFromToList = this.containerFromToListCopy;
      } else {
        let indexAll = this.selectedContainer.findIndex((data) => data.cc === 'ALL');

        if (indexAll > -1) {
          this.selectedContainer.splice(indexAll, 1);
        }
      }

      // Both containerFromList and containerToList should include all values that start with selectedContainer values
      console.log('from', this.containerFromList, this.selectedContainer);
      this.containerFromList = this.containerFromList.filter((container) =>
        this.selectedContainer.some((selected) => container.container_renban.startsWith(selected.cc))
      );
      this.containerToList = this.containerFromList.filter((container) =>
        this.selectedContainer.some((selected) => container.container_renban.startsWith(selected.cc))
      );
      this.containerFromToList = this.containerFromToList.filter((container) =>
        this.selectedContainer.some((selected) => container.container_renban.startsWith(selected.cc))
      );
    }
  }

  onContainerFromChange() {
    if (this.selectedContainerFrom.length >= 1) {
      this.selectedContainerFrom = this.selectedContainerFrom.container_renban;
    }

    if (this.selectedContainerFrom) {
      this.containerToList = this.containerFromToList.filter(
        (item) => item.container_renban > this.selectedContainerFrom.container_renban
      );
    }
  }

  onContainerToChange() {
    if (this.selectedContainerTo.length >= 1) {
      this.selectedContainerTo = this.selectedContainerTo.container_renban;
    }

    if (this.selectedContainerTo) {
      this.containerFromList = this.containerFromToList.filter(
        (item) => item.container_renban < this.selectedContainerTo.container_renban
      );
    }
  }

  onLifeCycleChange(): void {
    if (this.selectedLifecycle.length >= 1) {
      if (this.selectedLifecycle[this.selectedLifecycle.length - 1].life_cycle === 'ALL') {
        this.selectedLifecycle = [];
        this.selectedLifecycle.push(this.lifecycleList[0]);
      } else {
        let indexAll = this.selectedLifecycle.findIndex((data) => data.life_cycle === 'ALL');

        if (indexAll > -1) {
          this.selectedLifecycle.splice(indexAll, 1);
        }
      }
    }
  }
  statusChange(): void {
    if (this.selectedStatus.length >= 1) {
      if (this.selectedStatus[this.selectedStatus.length - 1].air_order_status === 'ALL') {
        this.selectedStatus = [];
        this.selectedStatus.push(this.statusList[0]);
      } else {
        let indexAll = this.selectedStatus.findIndex((data) => data.air_order_status === 'ALL');

        if (indexAll > -1) {
          this.selectedStatus.splice(indexAll, 1);
        }
      }
    }
  }

  resetVariablesState(): void {
    this.uploadError = false;
    this.uploadEnabled = false;
    this.isEditMode = false;
    this.editEnabled = this.isEditMode;
    this.setPageSizeToAll(this.defaultPageSize);

    if (this.tapMainGrid) {
      this.headerCheckboxChecked = false;
      this.tapMainGrid.gridOptions.api.refreshHeader();
                setTimeout(() => {
        this.attachHeaderClickEvents();
      });

      this.resetGrid();
    }
  }

  cancelEdit(): void {
    this.openConfirmationDialog();
  }

  openConfirmationDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '20 4px';
    dialogConfig.width = '470px';

    const dialogRef = this.dialog.open(ConfirmCancelDailogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((res) => {
      if (res === 'cancel') {
        this.isEditMode = !this.isEditMode;
        this.editEnabled = this.isEditMode;
        this.resetVariablesState();
        this.tapMainGrid.gridOptions.api.forEachNode(function (rowNode, index) {
          if (rowNode.data.rowCheckBox) {
            rowNode.setSelected(false);
            rowNode.data.checkedEditMode = false;
            rowNode.data.rowCheckBox = false;

            // Set old data to editable fields
            rowNode.data.rev_min_qty = rowNode.data.old_rev_min_qty;
            rowNode.data.rev_max_qty = rowNode.data.old_rev_max_qty;
          }
          rowNode.setData(rowNode.data);
        });

        this.headerCheckboxChecked = false;

        this.tapMainGrid.gridOptions.api.refreshHeader();
                  setTimeout(() => {
        this.attachHeaderClickEvents();
      });


        this.onSearch(0);
      }
    });
  }

  getWrappedColumn(v) {
    return { v, t: 's', s: { alignment: { wrapText: true } } };
  }

  modifyRowDataForExport(data) {
    const modifiedDataForExport = [];

    for (const row of data) {
      if (row.cont_code === 'ALL') {
        continue;
      }

      modifiedDataForExport.push({
        ...row,
        item_id: row.item_id ? row.item_id : row.hidden_item_id,
        kanban: row.kanban ? row.kanban : row.hidden_kanban,
        vanning_date: row.vanning_date ? row.vanning_date : row.hidden_vanning_date,
        order_lot: row.order_lot ? row.order_lot : row.hidden_order_lot,
      });
    }

    return modifiedDataForExport;
  }

  getExportData() {
    const data = [];

    const dataToExport = this.uploadError
      ? this.excelService.uploadedData
      : this.modifyRowDataForExport(this.exportData);

    // Normal export means user is normally exporting
    // There are no errors or it is not going to be uploaded
    const normalExport = !this.validating && !this.uploadEnabled && !this.uploadError && !this.uploading;

    dataToExport.forEach((row) => {
      const fa_comment = row.fa_comment;
      // typeof row.comment === 'string' && row.comment?.length > 0
      //   ? row.comment
      //   : row.fa_comment ?? '';

      const newRow = {
        vanning_date: row.vanning_date,
        item_id: row.item_id,
        kanban: row.kanban,
        cont_code: row.cont_code,
        order_lot: row.order_lot,
        fa_min_orig: row.orig_min_qty,
        fa_max_orig: row.orig_max_qty,
        fa_min_final: row.rev_min_qty,
        fa_max_final: row.rev_max_qty,
        fa_comment: fa_comment,
        remarks: row.errors?.join('\r\n'),
      };

      if (normalExport) {
        delete newRow['fa_comment'];
        delete newRow['remarks'];
      }

      Object.keys(newRow).forEach((key) => {
        newRow[key] = this.getWrappedColumn(newRow[key]);
      });

      data.push(newRow);
    });

    return data;
  }

  getExportDataSameAsUI() {
    const data = [];

    this.exportData.forEach((row) => {
      const {
        vanning_date,
        item_id,
        part_description,
        kanban,
        cont_code,
        order_lot,
        specialist,
        orig_min_qty,
        orig_max_qty,
        rev_min_qty,
        rev_max_qty,
        date_time,
        userid,
        fa_comment,
      } = row;

      // Prepare comments string for Excel Export/Download
      // 1st replace all replaces parts of a single comment
      // 2nd replace removes $ at the start without adding preceeding new lines
      // 3rd replace replaces $ and adds new lines
      const comments = fa_comment && fa_comment.replaceAll('#', '  ').replace('$', '').replaceAll('$', '\n\n');

      // Keys should be same as in Show/Hide List
      const newRow = {
        vanning_date,
        item_id,
        part_description,
        kanban,
        cont_code,
        order_lot,
        specialist,
        orig_min_qty,
        orig_max_qty,
        revMinQtyText: rev_min_qty,
        revMaxQtyText: rev_max_qty,
        date_time,
        userid,
        comment: comments ?? '',
      };

      const showHideValues: string[] = this.selectedShowHideList.map((item) => item.value);

      Object.keys(newRow).forEach((key) => {
        newRow[key] = this.getWrappedColumn(newRow[key]);

        // Show/Hide does not have vanning date, but it is needed in export/download
        if (key === 'vanning_date') return;

        // Remove keys of columns which are hidden
        if (!showHideValues.includes(key)) {
          delete newRow[key];
        }
      });

      data.push(newRow);
    });

    return data;
  }



  exportAsXLSX(): void {
    this.removeMessage();

    this.spinner.show();

    // eastern time api
    const easternCurrentDate = String(mm().tz(this.timeZone).format('YYYY-MM-DD_HH:mm:ss'));
    // console.log(easternCurrentDate);
    let data = [];

    if (this.headerCheckboxChecked) {
      this.tapMainGrid.gridOptions.api.forEachNodeAfterFilter((node) => {
        data.push(node.data);
      });
    } else {
      data = this.getModifiedRowData();
    }

    if (data.length < 1) {
      this.spinner.hide();
      this.warningMessage = warningMessage.noRowsSelected;

      window.scroll(0, 0);
    } else {
      setTimeout(async () => {
        if (this.rowData.length > 0) {
          const exportData: any = [];
          // const keyName = `kanban_${kanban}`;

          data.forEach((e) => {
            const obj: any = {
              container_renban: e.module_number === 'ALL' ? e.container_renban : '', // 1️⃣ First field
              module_number: e.module_number === 'ALL' ? '' : e.module_number,

            };

            // 2️⃣ Add dynamic kanban fields
            this.selectedKanban.forEach((kanban) => {
              const keyName = `kanban_${kanban}`;
              obj[keyName] = e[keyName];
            });

            // 3️⃣ Add remaining static fields
            Object.assign(obj, {
              tot_kb_count: e.module_number === 'ALL' ? '' : e.tot_kb_count,
              can_tap_kb_count: e.module_number === 'ALL' ? '' : e.can_tap_kb_count,
              cnt_status: e.cnt_status,
              cnt_est_arr_dt: e.cnt_est_arr_dt,
              user_entry: e.user_entry,
              planned_stocking_datetime: e.planned_stocking_datetime,
              updated_date_time: e.updated_date_time,
              updated_userid: e.updated_userid,
            });
            exportData.push(obj);
          });

          let headers = [
            'Container',
            'Module',
            ...this.selectedKanban.map((kanban) => `Kanban ${kanban}`),
            'Total KB Count',
            'Available KB Count',
            'Container Status',
            'Estimated Arrival',
            'User Entry',
            'Planned Stock Date',
            'Updated DT',
            'User',
          ];

          const timestamp = easternCurrentDate
            .split('.')[0]
            .replace('T', '_')
            .split('')
            .filter((d) => d !== '-' && d !== ':')
            .join('');

          this.excelService.exportAsExcelFile(exportData, 'Container-Tap_' + timestamp, headers);
        }
        this.spinner.hide();
      }, 1000);
    }
  }

  fa_columns;
  onShowHideChange(ev: any) {
    this.tapMainGrid.gridOptions.columnApi.setColumnsVisible([...this.showHideList.map((e) => e.value)], true);

    const hideItems = this.showHideList.filter((item) => {
      return !ev.value.map((sItem) => sItem.value).includes(item.value);
    });

    this.tapMainGrid.gridOptions.columnApi.setColumnsVisible([...hideItems.map((e) => e.value)], false);

    if (ev.onInit) return;

    this.fa_columns = hideItems;
    if (!hideItems.length) this.fa_columns = [{}];
  }

  saveShowHide() {
    this.spinner.show();
    let fa_columns = this.fa_columns;
    if (fa_columns) {
      this.lookupService.updateUserShowHideColumns({ fa_columns }).subscribe({
        error: (error) => this.errorCallback(error, 'updateUserShowHideColumns'),
        next: (res) => {
          // console.log(res);
          this.spinner.hide();
        },
      });
    } else {
      this.spinner.hide();
    }
  }

  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  }
  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9]/g, '');
  }
  getFilteredKanbanList(index: number): any[] {
    const selectedValues = this.selectedKanban.slice(0, index); // Get selected values up to the current index
    return this.kanbanList.filter((kanban) => !selectedValues.includes(kanban.kanban)); // Exclude already selected Kanbans
  }

  async appendprocurementDetails() {
    this.selectedDock = this.dockList.find((x) => x.dock === this.orderDetailsForEdit?.dock) || '';

    await this.onDockChange();
    if (this.orderDetailsForEdit?.kanban) {
      this.selectedKanban = [this.orderDetailsForEdit.kanban];
      await this.onKanbanChange();
      await this.onSearch(0);
    } else {
      this.selectedKanban = [];
    }
  }
attachHeaderClickEvents() {
  const headers = document.querySelectorAll('.custom-header-link');

  headers.forEach((el: any) => {
    el.addEventListener('click', (event: any) => {
      event.stopPropagation();

      const field = el.getAttribute('data-field');

      console.log('Clicked field:', field); // 

      this.gethistoryData(field);
    });
  });
}   
 openDialog(data,kanbanId) {
  var data2= {
    rowData: data,
    kanbanId: kanbanId,   
  }
  
  console.log(data)
      if (data.length > 0) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.id = 'modal-component';
        dialogConfig.height = '550px';
        dialogConfig.width = '1200px';
  
        dialogConfig.data = data2;
        const dialogRef = this.dialog.open(KanbanHistoryDialogComponent, dialogConfig, );
        dialogRef.afterClosed().subscribe((res) => {
          if (res === 'cancel') {
            return;
          }
        });
      }
    }

    gethistoryData(field){
     const kanbanId = field.split('_')[1];  // "1234" as string
      console.log('Kanban ID:', kanbanId);

      var historydata=[]
      const data = {
      business_entity: this.namcValue,
      dock: this.selectedDock.dock,
      kanban: kanbanId,
      user_role: this.userRole,
    };

    // console.log(data, 'onloadData')
    this.spinner.show();
    this.containerTapService.getTaphistory(data).subscribe({
      error: this.errorCallback,
      next: (res) => {
        // console.log(res, 'res')
        this.spinner.hide();
        let scheduleData = res.body.data;
        if (scheduleData.length > 0) {
          historydata = scheduleData;
          this.openDialog(historydata,kanbanId)
        } else {
          historydata = [];
          this.spinner.hide();
          this.warningMessage=`No history for kanban '${kanbanId}'`
        }
      },
    });
    return true;

    }
}
